import { InputComponent } from "components/components/Component";
import { InputBaseComponent, InputBaseDefinition } from "components/input/baseInputDefinition";
import { LabelElement } from "components/components/label/labelElement";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { initSignatureWebComponent, SignatureElement, SignatureTypeDataURL } from "components/signature/signatureElement";
import $ from "jquery";
import template from "./signature.hbs";
import "./signature.scss";

initSignatureWebComponent();

export class Signature extends InputBaseComponent<SignatureDefinition> implements InputComponent {

    public readonly componentType: string = "signature";

    private element: SignatureElement;

    constructor(definition: SignatureDefinition) {
        super(definition);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        return this.view;
    }

    public renderTemplate(): Element {
        let jqueryView = $(template(this.definition));
        this.view = jqueryView[0];
        return this.view;
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-signature");

        this.element.addEventListener("change", () => {
            const data = this.element.data;
            fireDataChangedEvent(this, this.view, data);
        });
    }

    public postRender() {
        //Ajusta el tamano de canvas al contenedor
        this.element.postRender();
    }

    public value(v: string) {
        if ((v == null) || ((v as unknown) === "")) {
            this.element.data = null;
        } else {
            this.element.data = v;
        }
    };

    public getValue(): string {
        return this.element.data;
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }

}

export interface SignatureDefinition extends InputBaseDefinition {
    signatureTypeDataURL: SignatureTypeDataURL.PNG | SignatureTypeDataURL.JPEG | SignatureTypeDataURL.SVG;
}
